import { LifeSkillsLevel } from 'api';

export const getLifeSkillsLevelName = (levelType: LifeSkillsLevel): string => {
  const levelTypeNames: Record<LifeSkillsLevel, string> = {
    [LifeSkillsLevel.A1]: 'A1',
    [LifeSkillsLevel.A2]: 'A2',
    [LifeSkillsLevel.B1]: 'B1',
  };
  return levelTypeNames[levelType] ?? '-';
};
